/* React & libraries */
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

/* Helpers */
import ConnectedIntlProvider from 'app/connectedIntlProvider';
import { persistor, store } from 'app/store';

/* Router configuration */
import { useAppRouter } from 'useAppRouter';

/* Modal Context and Navigation */
import { FloatingTree } from '@floating-ui/react';
import AppStateManager from 'app/AppStateManager';
import { AuthProvider } from 'components/auth/AuthProvider';
import { ModalProvider } from 'components/modal/ModalContext';
import { NavigationProvider } from 'components/navigation/NavigationContext';

/* CSS */
import 'bootstrap/dist/css/bootstrap.min.css';
import 'css/styles.scss';

function AppContent() {
  const element = (
    <FloatingTree>
      <NavigationProvider>
        <ModalProvider>
          <AuthProvider>
            <AppStateManager />
          </AuthProvider>
        </ModalProvider>
      </NavigationProvider>
    </FloatingTree>
  );

  const router = useAppRouter(element);

  return (
    <ConnectedIntlProvider>
      <div id="App">
        <RouterProvider router={router} />
      </div>
    </ConnectedIntlProvider>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppContent />
      </PersistGate>
    </Provider>
  );
}
